import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function User($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }],
		["circle", { "cx": "12", "cy": "7", "r": "4" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiVXNlci5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJNMTkgMjF2LTJhNCA0IDAgMCAwLTQtNEg5YTQgNCAwIDAgMC00IDR2MlwiIH1dLCBbXCJjaXJjbGVcIiwgeyBcImN4XCI6IFwiMTJcIiwgXCJjeVwiOiBcIjdcIiwgXCJyXCI6IFwiNFwiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7Z0RBRGxDLENBQUM7T0FFTyxRQUE0QztHQUFLLE1BQU0sSUFBSSxHQUFHLEVBQUUsMkNBQTJDO0dBQU0sUUFBUSxJQUFJLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRzs7O0tBQzlKLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9